import React, { useCallback, useState } from 'react';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import TrueImpactButton from 'shared/design-system/components/TrueImpactButton';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import styled from 'styled-components';
import { deleteReportAnswers } from '../AnswersModal/api';
import { useClient } from 'shared/apollo';
import TrueImpactModal from 'shared/design-system/components/TrueImpactModal';
import TrueImpactSimpleModal from 'shared/design-system/components/TrueImpactSimpleModal';

export interface SectionAnswers {
  dbId: number;
  text: string;
  questionId: number;
}

interface StaledReportProps {
  reportId: string | number;
  sectionAnswers?: SectionAnswers[];
}

const StyledDiv = styled.div`
  margin-top: ${SPACERS.large};
  .restart-impact-summary {
    margin-left: auto;
    margin-right: auto;
    margin-top: ${SPACERS.large};
  }
  .error-text {
    margin-top: ${SPACERS.large};
  }
`;

const StaledReport: React.FC<StaledReportProps> = ({
  reportId,
  sectionAnswers,
}) => {
  const client = useClient();
  const [state, setState] = useState<'init' | 'loading' | 'error' | 'success'>(
    'init',
  );

  const restartImpactSummary = useCallback(async () => {
    setState('loading');
    try {
      await deleteReportAnswers(
        client!,
        sectionAnswers!.map(x => x.dbId),
        Number(reportId),
        'impact_summary',
      );
    } catch (e) {
      setState('error');
      return;
    }
    setState('success');
  }, [reportId, sectionAnswers, client, setState]);

  const serviceName = sectionAnswers?.find(x => x.questionId === 40003)?.text;

  return (
    <StyledDiv>
      <TrueImpactText color="critical" align="center">
        You may have a stale service data. Please contact the support regarding
        this issue.
        <br />
        Report id: <strong>{reportId}</strong>
        <br />
        Selected Service: <strong>{serviceName || 'Unknown'}</strong>
      </TrueImpactText>
      {state === 'error' && (
        <TrueImpactText color="critical" align="center" className="error-text">
          An error occurred while restarting the impact model builder. Please
          try again.
        </TrueImpactText>
      )}
      <TrueImpactButton
        isLoading={state === 'loading'}
        onClick={restartImpactSummary}
        className="restart-impact-summary"
      >
        Restart Impact Model Builder
      </TrueImpactButton>
      <TrueImpactSimpleModal
        open={state === 'success'}
        onClose={undefined}
        next={{
          text: 'Refresh the page',
          onClick: () => window.location.reload(),
        }}
      >
        <TrueImpactText align="center" style={{ padding: SPACERS.large }}>
          Successfully removed stale impact model builder.
          <br />
          Please refresh the page to see the changes.
        </TrueImpactText>
      </TrueImpactSimpleModal>
    </StyledDiv>
  );
};

export default StaledReport;
